
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DocumentDetailDto } from '../../../shared/models/document-details-dto';
import { DocumentAttachmentDetails } from '../../models/document-attachment-details';
import { DocumentService } from '../../services/document.service';

@Component({
  selector: 'app-document-attachments',
  templateUrl: './document-attachments.component.html',
  styleUrls: ['./document-attachments.component.scss']
})
export class DocumentAttachmentsComponent implements OnInit {
  @Input() documentDetailsDto!: DocumentDetailDto;
  @Input() documentAttachments: DocumentAttachmentDetails[] = [];

  constructor(private documentService: DocumentService) { }

  ngOnInit(): void {
  }
  downloadAttachment = (fileId: string, fileName: string) => {
    this.documentService.downloadFile(fileId).subscribe((response) => {
      const fileUrl = response.fileUri;
      let downloadLink = document.createElement('a');
      document.body.appendChild(downloadLink);
      downloadLink.setAttribute('style', 'display: none');
      downloadLink.href = fileUrl;
      downloadLink.download = fileName;
      downloadLink.target = '_blank';
      downloadLink.click();
      downloadLink.remove();
    })
  }

}
